<template>
  <div class="compBox">
    <div class="table" v-loading="loading">
      <!-- <div class="tit">招生计划</div> -->
      <div class="selectBox">
 
        <el-select
          size="small"
          style="width: 250px; margin-right: 5px"
          v-model="provinceCode"
          placeholder="请选择"
          @change="YearsChange($event)"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.Code"
            :label="item.ProvinceName"
            :value="item.Code"
          >
          </el-option>
        </el-select>
      </div>
      <div style="height: 31px">
        <div class="pl20 dir-td f14 fw600">
          招生方向：{{ name }}({{ code }})
        </div>
      </div>
      <div style="height: 36px">
        <table class="my-table head" style="top: 154px; width: 100%">
          <thead class="my-table-head fw400">
            <th width="100">代码</th>
            <th class="text-left pl20">院校/专业名称</th>
            <th width="80">{{ startYear }}年招生</th>
            <th width="80">{{ startYear-1 }}年招生</th>
          </thead>
        </table>
      </div>
      <div class="tab">
        <table class="my-table body">
          <tbody class="my-table-body">
            <tr v-for="(it, idx) in list" :key="idx">
              <td width="100" class="text-center">
                <span class="cntext">{{ it.majorCode }}</span>
              </td>
              <td class="pt20 pb20 pl20">
                <a
                  href="http://zy.ycymedu.com/majors/small?code=140101"
                  target="_blank"
                  class="flex-column text-color-title"
                >
                  <span class="cntext fw600 f14"
                    >{{ it.majorName }}({{ it.majorCode }})</span
                  >
                  <span class="cntext f12 text-999 mt5"
                    >{{ it.majroRemark }};({{ it.selectsubject }})</span
                  >
                </a>
              </td>
              <td width="80" class="text-center">
                <span class="cntext" style="font-weight: bold; font-size: 14px"
                  >{{ it.newPlan }}人</span
                >
                <span
                  v-if="it.newPlan >= it.oldPlan"
                  style="
                    margin-left: 5px;
                    background: rgb(175, 220, 183);
                    color: rgb(24, 173, 51);
                    font-size: 12px;
                    padding: 2px 5px;
                  "
                  >{{ it.newPlan - it.oldPlan }}</span
                >
                <span
                  v-else
                  style="
                    margin-left: 5px;
                    background: rgb(220, 191, 175);
                    color: rgb(173, 24, 81);
                    font-size: 12px;
                    padding: 2px 5px;
                  "
                  >{{ Math.abs(it.newPlan - it.oldPlan) }}</span
                >
              </td>
              <td width=" 80" class="text-center">
                <span class="cntext">{{ it.oldPlan }}人</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { GetMajorPlanPro } from "@/api/schoolDetails";
import { GetSeVolunteerInitialization } from "@/api/home";

export default {
  name: "VoluntaryReportingIndex",
  props: {
    schoolId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      provinceCode:"",
      Year: "",
      list: [],
      loading: false,
      provinceList: [],
      SearchCount: 0,
      isVipSearchShow: false,
      startYear:""
    };
  },
  created(){
     this.provinceCode = this.$store.state.user.studentInfo.userExtend.provinceCode || "001";
  },

  mounted() {
    this.Year = this.$store.state.user.studentInfo.userExtend.year || 2024;
    this.getList();
    this.getSeVolunteerList();
  },

  methods: {
    // 获取省份
    async getSeVolunteerList() {
      const res = await GetSeVolunteerInitialization();
      this.provinceList = res.data.response;
    },
    YearsChange() {
      this.getList();
      console.log(this.provinceCode);
      
    },
    async getList() {
      const res = await GetMajorPlanPro({
        uid: this.schoolId,
        locationCode: this.provinceCode,
        year: this.Year,
      });
      // this.provinceList[0].label = res.data.response.UniversityName;
      this.list = res.data.result.items;
      this.startYear = res.data.result.year
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
}

.bb {
  position: relative;
  width: 100%;

  button {
    position: absolute;
    top: 153px;
    left: 50%;
    transform: translateX(-50%);
    width: 142px;
    height: 49px;
    background: #28c445;
    border-radius: 10px;
    border: none;
    font-size: 24px;
    font-weight: 500;
    line-height: 49px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}

.compBox {
  margin-top: 60px;

  .table {
    .tit {
      font-weight: bold;
      font-size: 28px;
      margin-bottom: 30px;
    }

    .selectBox {
      margin-bottom: 10px;
    }

    .dir-td {
      padding: 5px 12px;
      background: #fafafa;
      line-height: 20px;
      color: #1d2129;
      border: 1px solid #e8e8e8;
      border-bottom: none;
      font-size: 14px;
      padding-left: 20px;
      font-weight: bold;
    }

    .my-table {
      background-color: #fff;
      border-bottom: 1px dashed #e9e9e9;
      border-right: 1px solid #e8e8e8;
      border-top: 1px solid #e8e8e8;
      border-collapse: collapse;
      border-spacing: 0;

      .my-table-head th:first-child {
        border-left: 1px solid #e8e8e8;
      }

      .my-table-head th {
        border-bottom: 1px solid #e8e8e8;
        padding: 9px 0;
        font-size: 12px;
        color: #86909c;
      }

      .text-left {
        text-align: left !important;
      }

      .pl20 {
        padding-left: 20px !important;
      }
    }

    .tab {
      .my-table.body {
        border-top: none;
        width: 100%;

        tr.stripe {
          background: #f7f7f7;
        }

        .text-color-title {
          color: #1d2129;
        }

        .text-center {
          text-align: center !important;
        }

        td {
          font-size: 12px !important;
          border-left: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          color: #333;
        }

        .pl20 {
          padding-left: 20px !important;
        }

        .pb20 {
          padding-bottom: 20px !important;
        }

        .pt20 {
          padding-top: 20px !important;
        }

        .flex-column {
          display: flex;
          text-decoration: none;
          flex-direction: column;

          .fw600 {
            font-weight: 600 !important;
          }

          .f14 {
            font-size: 14px !important;
          }

          .text-999 {
            color: #999 !important;
          }

          .f12 {
            font-size: 12px !important;
          }

          .mt5 {
            margin-top: 5px !important;
          }

          .cntext {
            font-family: cntext !important;
          }
        }
      }
    }
  }
}
</style>
